import { render, staticRenderFns } from "./VinculacionManual.vue?vue&type=template&id=363b1c79&scoped=true"
import script from "./VinculacionManual.vue?vue&type=script&setup=true&lang=js"
export * from "./VinculacionManual.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b1c79",
  null
  
)

export default component.exports